import { DownOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useEffect, useState, useCallback } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/action";
import { dataFetchError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import { getLabel } from "../../../../Util/EpollParser";
import CheckPermission from "../../../../Util/CheckPermission";
import { Button, Divider, Dropdown, List, Modal, Select, Tag, message } from "antd";
import styles from "./QuestionsReport.module.css";

const QuestionReport = ({ LoadingSetter, ClearLoading, loading, permissions }) => {
  const [data, setData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [answersData, setAnswersData] = useState([]);
  const [notesModal, setNotesModal] = useState(null);
  const [answersModal, setAnswersModal] = useState(null);
  const [formId, setFormId] = useState(67506);
  const [importantQuestions, setImportantQuestions] = useState([]);
  const [formReport, setFormReport] = useState(null);

  const canViewAnswers = CheckPermission(
    ["answers_report", "textual_answers_view", "reports_answers_note_count"],
    permissions
  );
  const canDownloadAnswers = CheckPermission(
    "textual_answers_download",
    permissions
  );

  const getQuestionNum = (record) => record.title.split(": ").at(0).trim();

  const openAnswersModal = (record) => {
    const questionNum = getQuestionNum(record);

    LoadingSetter();
    return api
      .get("/question/textual-answers", {
        params: {
          formId,
          questionId: questionNum,
          isEpoll: true,
        },
      })
      .then((res) => {
        setAnswersModal(record);
        setAnswersData(res.data);
      })
      .catch((err) => message.error("خطا در دریافت جواب کاربران"))
      .finally(() => ClearLoading());
  };

  const downloadAnswersExcel = (record) => {
    const questionNum = getQuestionNum(record);

    LoadingSetter();
    return api
      .get("/question/textual-answers/excel", {
        params: {
          formId,
          questionId: questionNum,
          isEpoll: true,
        },
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `answers-${formId}-${questionNum}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => message.error("خطا در دانلود جواب کاربران"))
      .finally(() => ClearLoading());
  };

  const renderAnswersMenu = (record) => {
    if (
      record.question_type !== "text" &&
      record.question_type !== "paragraph"
    ) {
      return null;
    }

    const items = [];
    if (canViewAnswers) {
      items.push({ key: "view", label: "مشاهده" });
    }
    if (canDownloadAnswers) {
      items.push({ key: "download", label: "دانلود" });
    }
    if (items.length === 0) return null;

    return (
      <Dropdown
        trigger={["click"]}
        menu={{
          items,
          onClick: ({ key }) => {
            if (key === "view") openAnswersModal(record);
            if (key === "download") downloadAnswersExcel(record);
          },
        }}
      >
        <Button size="small" style={{ marginLeft: "0.4rem" }}>
          جواب ها <DownOutlined />
        </Button>
      </Dropdown>
    );
  };

  const columns = [
    // question
    {
      title: "سوال",
      dataIndex: "title",
      searchable: true,
      width: "50%",
      editable: false,
    },
    // bookmark
    {
      title: "تعداد بوکمارک",
      dataIndex: "count",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        let totalStarsA = getBookmarkCount(a.id).length;
        let totalStarsB = getBookmarkCount(b.id).length;

        return totalStarsA - totalStarsB;
      },
      render: (_, record) => {
        if (record.isOption) return "-";
        return getBookmarkCount(record.id).length;
      },
    },
    // stars
    {
      title: "تعداد ستاره",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        let totalStarsA = getStarsCount("null", a.id).length;
        let totalStarsB = getStarsCount("null", b.id).length;

        a?.children?.forEach((child) => {
          totalStarsA += getStarsCount(child.id, child.anwser_id).length;
        });

        b?.children?.forEach((child) => {
          totalStarsB += getStarsCount(child.id, child.anwser_id).length;
        });

        return totalStarsA - totalStarsB;
      },
      render: (_, record) => {
        if (!record.isOption && Array.isArray(record.children)) return "-";
        if (!record.isOption) return getStarsCount("null", record.id).length;
        return getStarsCount(record.id, record.anwser_id).length;
      },
    },
    // detail
    {
      title: "جزئیات",
      dataIndex: "notes",
      align: "center",
      filters: [{ text: "فقط سوالات متنی", value: "text" }],
      onFilter: (value, record) => {
        if (value === "text") {
          return (
            record.question_type === "text" ||
            record.question_type === "paragraph"
          );
        }

        return record.question_type === value;
      },
      render: (notes, record) => {
        let starCount = 0;
        let bookmarkCount = 0;
        if (!record.isOption) {
          starCount = getStarsCount("null", record.id).length;
          bookmarkCount = getBookmarkCount(record.id).length;
        } else {
          starCount = getStarsCount(record.id, record.anwser_id).length;
        }

        if (bookmarkCount === 0 && starCount === 0) {
          return (
            <>
              {renderAnswersMenu(record)}
              <Tag color="red">ندارد</Tag>
            </>
          );
        }

        return (
          <>
            {renderAnswersMenu(record)}
            <Button
              onClick={() => {
                setNotesModal(record);
              }}
            >
              مشاهده
            </Button>
          </>
        );
      },
    },
  ];

  const loadStatistics = () => {
    api
      .get("/roadmaps/report/answersnotecount")
      .then(({ data: responseData }) => {
        setReportData(responseData);
      })
      .catch((err) => {
        ClearLoading();
        dataFetchError();
      });
  };

  const loadData = () => {
    LoadingSetter();
    actions
      .getQuestions(formId)
      .then((a) => {
        setData(a.data);
      })
      .finally(() => ClearLoading());
  };

  const getBookmarkCount = (questionId) => {
    return reportData
      .filter((repData) => repData?.answersNote)
      .filter((roadmap) => {
        const keysOfObj = Object.keys(roadmap?.answersNote);

        for (const singleKey of keysOfObj) {
          if (
            `${singleKey}` === `${questionId}` ||
            `${singleKey}` === `${questionId}_null`
          ) {
            const el =
              roadmap?.answersNote[`${questionId}`] ??
              roadmap?.answersNote[`${questionId}_null`];

            return el.bookmark;
          }
        }

        return false;
      });
  };

  const getStarsCount = (questionId, answerId) => {
    return reportData
      .filter((repData) => Array.isArray(repData?.starQuestions?.questionIds))
      .filter((roadmap) =>
        roadmap?.starQuestions?.questionIds.includes(
          `${answerId}_${questionId}`
        )
      );
  };

  const loadImportantQuestions = useCallback(() => {
    if (!formId) return;
    api
      .get("/important-questions", {
        params: { formId },
      })
      .then(({ data }) => {
        setImportantQuestions(data.data || []);
      })
      .catch(() => message.error("خطا در دریافت سوالات مهم"));
  }, [formId]);

  const loadFormReport = useCallback(() => {
    if (!formId) return;
    const formKey = String(formId);
    api
      .get(`/forms/${formKey}/report`)
      .then(({ data }) => {
        setFormReport(data);
      })
      .catch(() => message.error("خطا در دریافت گزارش فرم"));
  }, [formId]);

  const isRecordImportant = (record) => {
    if (!Array.isArray(importantQuestions) || importantQuestions.length === 0) {
      return false;
    }

    // Try matching by IDs first (new API structure)
    const questionId = record.isOption ? record.anwser_id : record.id;
    const optionId = record.isOption ? record.id : null;

    const matchById = importantQuestions.find(
      (iq) =>
        iq.questionId == questionId &&
        (optionId === null
          ? iq.optionId === null || iq.optionId === undefined
          : iq.optionId == optionId)
    );

    if (matchById) return true;

    // Fallback: Try matching by questionNumber (for backward compatibility)
    if (record.title) {
      return importantQuestions.some((iq) => {
        // If API still returns questionNumber
        if (iq.questionNumber) {
          const questionNumber = iq.questionNumber;
          if (typeof iq.answerId !== "undefined" && iq.answerId !== null) {
            return (
              (record.title.startsWith(questionNumber + " ") ||
                record.title.startsWith(questionNumber + ":")) &&
              iq.answerId == record.answer_id
            );
          } else {
            return (
              record.title.startsWith(questionNumber + " ") ||
              record.title.startsWith(questionNumber + ":")
            );
          }
        }
        return false;
      });
    }

    return false;
  };

  useEffect(() => {
    loadData();
    loadStatistics();
    loadImportantQuestions();
    loadFormReport();
  }, [formId, loadImportantQuestions, loadFormReport]);

  return (
    <>
      <DataTable
        tableKey="questions-report"
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        recordCreatorDisabled
        header={{
          title: (
            <Select
              value={formId}
              onChange={setFormId}
              options={[
                {
                  value: 67506,
                  label: <span>گزارش سوالات لایف کوچ اتوماتیک</span>,
                },
                {
                  value: 41744,
                  label: <span>گزارش سوالات روانشناسی</span>,
                },
              ]}
            />
          ),
          avatar: { icon: <QuestionCircleOutlined />, size: "large" },
        }}
        rowClassName={(record) => {
          const classes = [];
          if (isRecordImportant(record)) {
            classes.push("row_error");
          }

          return [
            record.anwser_id ? styles.AwnserRow : null,
            record.question_type === "break" ? styles.Break : null,
            ...classes,
          ].join(" ");
        }}
      />

      {/* report modal */}
      <Modal
        open={notesModal}
        closable={true}
        onCancel={() => setNotesModal(null)}
        destroyOnClose
        footer={[
          <Button
            onClick={() => {
              setNotesModal(null);
            }}
          >
            فهمیدم
          </Button>,
        ]}
      >
        <br />
        <b>{notesModal?.title}</b>
        <Divider
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            borderColor: "#ccc",
          }}
        />
        <div style={{ display: "flex" }}>
          {/* bookmark */}
          {!notesModal?.isOption && (
            <div
              style={{
                width: "50%",

                borderLeft: "1px solid rgba(0,0,0,0.2)",
              }}
            >
              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                گزارش بوکمارکی
              </p>
              <List>
                {getBookmarkCount(notesModal?.id).map((rec) => (
                  <List.Item>{`${rec?.users_permissions_user?.firstname} ${rec?.users_permissions_user?.lastname} - ${rec.users_permissions_user.username}`}</List.Item>
                ))}
              </List>
            </div>
          )}
          <div
            style={{
              width: notesModal?.isOption ? "100%" : "50%",
              borderRight: notesModal?.isOption
                ? ""
                : "1px solid rgba(0,0,0,0.2)",
            }}
          >
            <p
              style={{
                fontSize: "1rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              گزارش ستاره دار
            </p>
            <List>
              <List>
                {(notesModal?.isOption
                  ? getStarsCount(notesModal?.id, notesModal?.anwser_id)
                  : getStarsCount("null", notesModal?.id)
                ).map((rec) => (
                  <List.Item>{`${rec?.users_permissions_user?.firstname} ${rec?.users_permissions_user?.lastname} - ${rec.users_permissions_user.username}`}</List.Item>
                ))}
              </List>
            </List>
          </div>
        </div>

        <Divider
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            borderColor: "#ccc",
          }}
        />
      </Modal>

      {/* answers modal */}
      <Modal
        open={answersModal}
        closable={true}
        onCancel={() => setAnswersModal(null)}
        destroyOnClose
        footer={[<Button onClick={() => setAnswersModal(null)}>فهمیدم</Button>]}
      >
        <br />
        <b>{answersModal?.title}</b>
        <Divider
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            borderColor: "#ccc",
          }}
        />
        <List>
          {answersData.map((rec) => (
            <List.Item>
              <span
                style={{ fontWeight: "bold" }}
              >{`${rec?.user?.firstname} ${rec?.user?.lastname} - ${rec?.user?.username}: `}</span>
              {rec.answer}
            </List.Item>
          ))}
        </List>

        <Divider
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            borderColor: "#ccc",
          }}
        />
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(QuestionReport);
